var _Variants$h, _Variants$h2, _Variants$h3, _Variants$h4, _Variants$h5, _Variants$p, _Variants$small, _defaultH1Variant$fon, _defaultH2Variant$fon, _defaultH3Variant$fon, _defaultH4Variant$fon, _defaultH5Variant$fon, _defaultPVariant$font, _defaultSmallVariant$, _defaultH1Variant$lin, _defaultH2Variant$lin, _defaultH3Variant$lin, _defaultH4Variant$lin, _defaultH5Variant$lin, _defaultPVariant$line, _defaultSmallVariant$2, _defaultH1Variant$let, _defaultH2Variant$let, _defaultH3Variant$let, _defaultH4Variant$let, _defaultH5Variant$let, _defaultPVariant$lett, _defaultSmallVariant$3;
import { bookGotham, bookSentinel, Family as FontFamily, lightSentinel, mediumBigCaslon, mediumGotham, mediumSentinel, Weight as FontWeight } from "./utils";
/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export var Weight = FontWeight;
/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export var Family = FontFamily;
/** @deprecated use variants from Typography instead */
export var getWeight = function getWeight(weight) {
  if (weight in Weight) {
    return Weight[weight];
  }
  return weight;
};
/** @deprecated Don't use uppercase or capitalize. We are using sentence case instead */
export var TextTransform = {
  capitalize: "capitalize",
  uppercase: "uppercase"
};
/**
 * Typography definition factory for producing the variants
 * for a given font configuration.
 * @deprecated Use themes instead.
 */
export var Variants = {
  h1: function h1(props) {
    return {
      "font-family": props.serif ? mediumBigCaslon : mediumGotham,
      "font-weight": Weight.medium,
      "font-size": "52px",
      "line-height": "64px",
      "letter-spacing": "2px"
    };
  },
  h2: function h2(props) {
    return {
      "font-family": props.serif ? mediumSentinel : mediumGotham,
      "font-weight": Weight.medium,
      "font-size": "28px",
      "line-height": "40px",
      "letter-spacing": props.serif ? "1.5px" : "1px"
    };
  },
  h3: function h3(props) {
    return {
      "font-family": props.serif ? bookSentinel : mediumGotham,
      "font-weight": props.serif ? Weight.book : Weight.medium,
      "font-size": "20px",
      "line-height": "32px",
      "letter-spacing": "1px"
    };
  },
  h4: function h4(props) {
    return {
      "font-family": props.serif ? lightSentinel : mediumGotham,
      "font-weight": props.serif ? Weight.light : Weight.medium,
      "font-size": "16px",
      "line-height": "28px",
      "letter-spacing": props.serif ? "1px" : "0.5px"
    };
  },
  h5: function h5(props) {
    return {
      "font-family": props.serif ? bookSentinel : bookGotham,
      "font-weight": Weight.book,
      "font-size": "12px",
      "line-height": "20px",
      "letter-spacing": "0.25px"
    };
  },
  p: function p(props) {
    return {
      "font-family": props.serif ? bookSentinel : bookGotham,
      "font-weight": Weight.book,
      "font-size": "12px",
      "line-height": "20px",
      "letter-spacing": "0.25px"
    };
  },
  small: function small(props) {
    return {
      "font-family": props.serif ? bookSentinel : bookGotham,
      "font-weight": Weight.book,
      "font-size": "10px",
      "line-height": "14px",
      "letter-spacing": "0.25px"
    };
  }
};
/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export var getVariantFamily = function getVariantFamily(variant, serif) {
  switch (variant) {
    case "h1":
      return serif ? Family.bigCaslon : Family.sansSerif;
    default:
      return serif ? Family.serif : Family.sansSerif;
  }
};
var defaultH1Variant = (_Variants$h = Variants.h1) === null || _Variants$h === void 0 ? void 0 : _Variants$h.call(Variants, {});
var defaultH2Variant = (_Variants$h2 = Variants.h2) === null || _Variants$h2 === void 0 ? void 0 : _Variants$h2.call(Variants, {});
var defaultH3Variant = (_Variants$h3 = Variants.h3) === null || _Variants$h3 === void 0 ? void 0 : _Variants$h3.call(Variants, {});
var defaultH4Variant = (_Variants$h4 = Variants.h4) === null || _Variants$h4 === void 0 ? void 0 : _Variants$h4.call(Variants, {});
var defaultH5Variant = (_Variants$h5 = Variants.h5) === null || _Variants$h5 === void 0 ? void 0 : _Variants$h5.call(Variants, {});
var defaultPVariant = (_Variants$p = Variants.p) === null || _Variants$p === void 0 ? void 0 : _Variants$p.call(Variants, {});
var defaultSmallVariant = (_Variants$small = Variants.small) === null || _Variants$small === void 0 ? void 0 : _Variants$small.call(Variants, {});
/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export var Size = {
  h1: (_defaultH1Variant$fon = defaultH1Variant === null || defaultH1Variant === void 0 ? void 0 : defaultH1Variant["font-size"]) !== null && _defaultH1Variant$fon !== void 0 ? _defaultH1Variant$fon : "",
  h2: (_defaultH2Variant$fon = defaultH2Variant === null || defaultH2Variant === void 0 ? void 0 : defaultH2Variant["font-size"]) !== null && _defaultH2Variant$fon !== void 0 ? _defaultH2Variant$fon : "",
  h3: (_defaultH3Variant$fon = defaultH3Variant === null || defaultH3Variant === void 0 ? void 0 : defaultH3Variant["font-size"]) !== null && _defaultH3Variant$fon !== void 0 ? _defaultH3Variant$fon : "",
  h4: (_defaultH4Variant$fon = defaultH4Variant === null || defaultH4Variant === void 0 ? void 0 : defaultH4Variant["font-size"]) !== null && _defaultH4Variant$fon !== void 0 ? _defaultH4Variant$fon : "",
  h5: (_defaultH5Variant$fon = defaultH5Variant === null || defaultH5Variant === void 0 ? void 0 : defaultH5Variant["font-size"]) !== null && _defaultH5Variant$fon !== void 0 ? _defaultH5Variant$fon : "",
  p: (_defaultPVariant$font = defaultPVariant === null || defaultPVariant === void 0 ? void 0 : defaultPVariant["font-size"]) !== null && _defaultPVariant$font !== void 0 ? _defaultPVariant$font : "",
  small: (_defaultSmallVariant$ = defaultSmallVariant === null || defaultSmallVariant === void 0 ? void 0 : defaultSmallVariant["font-size"]) !== null && _defaultSmallVariant$ !== void 0 ? _defaultSmallVariant$ : ""
};
/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export var LineHeight = {
  h1: (_defaultH1Variant$lin = defaultH1Variant === null || defaultH1Variant === void 0 ? void 0 : defaultH1Variant["line-height"]) !== null && _defaultH1Variant$lin !== void 0 ? _defaultH1Variant$lin : "",
  h2: (_defaultH2Variant$lin = defaultH2Variant === null || defaultH2Variant === void 0 ? void 0 : defaultH2Variant["line-height"]) !== null && _defaultH2Variant$lin !== void 0 ? _defaultH2Variant$lin : "",
  h3: (_defaultH3Variant$lin = defaultH3Variant === null || defaultH3Variant === void 0 ? void 0 : defaultH3Variant["line-height"]) !== null && _defaultH3Variant$lin !== void 0 ? _defaultH3Variant$lin : "",
  h4: (_defaultH4Variant$lin = defaultH4Variant === null || defaultH4Variant === void 0 ? void 0 : defaultH4Variant["line-height"]) !== null && _defaultH4Variant$lin !== void 0 ? _defaultH4Variant$lin : "",
  h5: (_defaultH5Variant$lin = defaultH5Variant === null || defaultH5Variant === void 0 ? void 0 : defaultH5Variant["line-height"]) !== null && _defaultH5Variant$lin !== void 0 ? _defaultH5Variant$lin : "",
  p: (_defaultPVariant$line = defaultPVariant === null || defaultPVariant === void 0 ? void 0 : defaultPVariant["line-height"]) !== null && _defaultPVariant$line !== void 0 ? _defaultPVariant$line : "",
  small: (_defaultSmallVariant$2 = defaultSmallVariant === null || defaultSmallVariant === void 0 ? void 0 : defaultSmallVariant["line-height"]) !== null && _defaultSmallVariant$2 !== void 0 ? _defaultSmallVariant$2 : ""
};
/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export var LetterSpacing = {
  h1: (_defaultH1Variant$let = defaultH1Variant === null || defaultH1Variant === void 0 ? void 0 : defaultH1Variant["letter-spacing"]) !== null && _defaultH1Variant$let !== void 0 ? _defaultH1Variant$let : "",
  h2: (_defaultH2Variant$let = defaultH2Variant === null || defaultH2Variant === void 0 ? void 0 : defaultH2Variant["letter-spacing"]) !== null && _defaultH2Variant$let !== void 0 ? _defaultH2Variant$let : "",
  h3: (_defaultH3Variant$let = defaultH3Variant === null || defaultH3Variant === void 0 ? void 0 : defaultH3Variant["letter-spacing"]) !== null && _defaultH3Variant$let !== void 0 ? _defaultH3Variant$let : "",
  h4: (_defaultH4Variant$let = defaultH4Variant === null || defaultH4Variant === void 0 ? void 0 : defaultH4Variant["letter-spacing"]) !== null && _defaultH4Variant$let !== void 0 ? _defaultH4Variant$let : "",
  h5: (_defaultH5Variant$let = defaultH5Variant === null || defaultH5Variant === void 0 ? void 0 : defaultH5Variant["letter-spacing"]) !== null && _defaultH5Variant$let !== void 0 ? _defaultH5Variant$let : "",
  p: (_defaultPVariant$lett = defaultPVariant === null || defaultPVariant === void 0 ? void 0 : defaultPVariant["letter-spacing"]) !== null && _defaultPVariant$lett !== void 0 ? _defaultPVariant$lett : "",
  small: (_defaultSmallVariant$3 = defaultSmallVariant === null || defaultSmallVariant === void 0 ? void 0 : defaultSmallVariant["letter-spacing"]) !== null && _defaultSmallVariant$3 !== void 0 ? _defaultSmallVariant$3 : ""
};
/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export default {
  Family: Family,
  Weight: Weight,
  LineHeight: LineHeight,
  Size: Size,
  LetterSpacing: LetterSpacing
};